module.exports = __webpack_public_path__ + "img/meetingdemo_wx.052f6644.jpg";